export const scrollToFirstError = () => {
  setTimeout(() => {
    const firstError =
      Array.from(document.querySelectorAll('body *')).find(
        el => el.textContent?.trim() === 'No Email Data'
      ) ||
      document.querySelector(
        '[data-icon="triangle-exclamation"][data-prefix="fas"]'
      );

    if (firstError) {
      firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }, 100);
};